import { useEffect } from "react";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogUrl?: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
}

const SEO = ({ title, description, keywords, canonical, ogUrl, ogImage, ogType = "business.business", noindex = false }: SEOProps) => {
  useEffect(() => {
    document.title = title;
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    }
    
    if (keywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute("content", keywords);
      }
    }

    // Robots noindex
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!metaRobots) {
        metaRobots = document.createElement("meta");
        metaRobots.setAttribute("name", "robots");
        document.head.appendChild(metaRobots);
      }
      metaRobots.setAttribute("content", "noindex, nofollow");
    } else if (metaRobots) {
      metaRobots.remove();
    }

    // Canonical tag
    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (!linkCanonical) {
        linkCanonical = document.createElement("link");
        linkCanonical.setAttribute("rel", "canonical");
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute("href", canonical);
    }

    // Open Graph tags
    const setMetaTag = (property: string, content: string) => {
      let metaTag = document.querySelector(`meta[property="${property}"]`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("property", property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute("content", content);
    };

    if (ogUrl) setMetaTag("og:url", ogUrl);
    if (ogImage) {
      setMetaTag("og:image", ogImage);
      setMetaTag("og:image:width", "1200");
      setMetaTag("og:image:height", "630");
    }
    if (ogType) setMetaTag("og:type", ogType);
    setMetaTag("og:title", title);
    setMetaTag("og:description", description);
    setMetaTag("og:locale", "fr_FR");

    // Twitter tags
    const setTwitterTag = (name: string, content: string) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute("content", content);
    };

    setTwitterTag("twitter:title", title);
    setTwitterTag("twitter:description", description);
    if (ogImage) setTwitterTag("twitter:image", ogImage);
  }, [title, description, keywords, canonical, ogUrl, ogImage, ogType, noindex]);

  return null;
};

export default SEO;
